/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smquizzes1Inputs */

const zh_landing_admin_smquizzes1 = /** @type {(inputs: Landing_Admin_Smquizzes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测验`)
};

const en_landing_admin_smquizzes1 = /** @type {(inputs: Landing_Admin_Smquizzes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quizzes`)
};

const es_landing_admin_smquizzes1 = /** @type {(inputs: Landing_Admin_Smquizzes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuestionarios`)
};

/**
* | output |
* | --- |
* | "Quizzes" |
*
* @param {Landing_Admin_Smquizzes1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smquizzes1 = /** @type {((inputs?: Landing_Admin_Smquizzes1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smquizzes1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smquizzes1(inputs)
	if (locale === "en") return en_landing_admin_smquizzes1(inputs)
	return es_landing_admin_smquizzes1(inputs)
});
export { landing_admin_smquizzes1 as "landing_admin_smQuizzes" }